import { createRoot } from 'react-dom/client'
import React from 'react'
import App from './app/App'
import { loadSnapshot } from './app/apis/snapshotApi'

const domNode = document.getElementById('matrix-shortcode')

if (domNode) {
    loadSnapshot(domNode).then(data => {
        if (data) {
            const root = createRoot(domNode)

            root.render(<App data={data} />)
        }
    })
}
